// extracted by mini-css-extract-plugin
export default {"external":"ax7mAr","deprecatedBorderRadius":"bx7mAr","hasAnimation":"cx7mAr","container":"dx7mAr"};